import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { X, ArrowRight } from 'lucide-react';

const LeadCapturePopup = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem('popup_shown');
    if (alreadyShown) {
      setDismissed(true);
      return;
    }

    // Show after 30 seconds
    const timer = setTimeout(() => {
      if (!dismissed) setShow(true);
    }, 30000);

    // Exit intent detection
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !dismissed && !sessionStorage.getItem('popup_shown')) {
        setShow(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [dismissed]);

  const handleClose = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem('popup_shown', 'true');
  };

  if (!show || dismissed) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="lead-capture-popup">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose}></div>
      <div className="relative bg-gradient-to-br from-[#111827] to-[#0B0F1A] border-2 border-[#00E5FF]/30 rounded-2xl p-8 max-w-md w-full shadow-2xl shadow-[#00E5FF]/20 animate-in zoom-in-95 fade-in duration-300">
        <button onClick={handleClose} className="absolute top-4 right-4 text-[#9CA3AF] hover:text-white transition-colors" data-testid="popup-close-btn">
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#00E5FF] to-[#1DE9B6] flex items-center justify-center mx-auto mb-5 shadow-lg shadow-[#00E5FF]/40">
            <span className="text-2xl font-bold text-[#0B0F1A]">?</span>
          </div>
          <h3 className="text-2xl font-bold text-white mb-3 font-['Space_Grotesk']">
            Wait! Don't miss out
          </h3>
          <p className="text-[#9CA3AF] text-sm leading-relaxed mb-6">
            Not sure which career path is right for you? Book a <span className="text-[#00E5FF] font-medium">FREE consultation</span> with our experts and get a personalized roadmap.
          </p>
          <Link to="/book-a-consultation" onClick={handleClose}>
            <Button className="w-full bg-[#00E5FF] hover:bg-[#1DE9B6] text-[#0B0F1A] font-bold py-5 text-base rounded-lg shadow-lg shadow-[#00E5FF]/40 mb-3" data-testid="popup-cta-btn">
              Book Free Career Call <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <button onClick={handleClose} className="text-[#9CA3AF] text-sm hover:text-white transition-colors">
            No thanks, I'll explore on my own
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadCapturePopup;
